import type { ReactNode } from 'react';

import DataError from '~/shared/components/data-error';
import Skeleton from '~/shared/components/skeleton';
import { NO_DATA_PLACEHOLDER } from '~/shared/constants';

import './content-placeholder.scss';

const ContentPlaceholder = ({
  isLoading = false,
  isError = false,
  height = '18px',
  className,
  isDataErrorPlaceholder = false,
  content = <span>{NO_DATA_PLACEHOLDER}</span>,
}: {
  isLoading: boolean;
  isError?: boolean;
  isDataErrorPlaceholder?: boolean;
  content: ReactNode | string;
  height?: string;
  className?: string;
}) => {
  return isLoading ? (
    <Skeleton height={height} className={className ?? 'content-placeholder'} />
  ) : isError ? (
    isDataErrorPlaceholder ? (
      <DataError />
    ) : (
      NO_DATA_PLACEHOLDER
    )
  ) : content === null || content === undefined ? (
    NO_DATA_PLACEHOLDER
  ) : (
    content
  );
};

export default ContentPlaceholder;
